import { Flex, Button, FormControl, Textarea } from '@chakra-ui/react';
import * as Yup from 'yup';
import { Form, Formik, FormikProps } from 'formik';
import axios from 'axios';

const DeclineFormValidation = Yup.object().shape({
  declineComment: Yup.string(),
});

const DeclineReferenceForm = ({
  referenceId,
  referenceRequestId,
  afterSubmit,
}: DeclineReferenceFormProps): JSX.Element => {
  const submitReference = async (referenceDetails: UpdateReferenceDetails) => {
    await axios({
      baseURL: process.env.REACT_APP_FUNCTIONS_URL,
      url: '/references/submitReference',
      method: 'POST',
      data: {
        ...referenceDetails,
      },
    });
  };
  return (
    <Flex width="100%">
      <Formik
        key="decline"
        validationSchema={DeclineFormValidation}
        initialValues={{
          declineComment: '',
        }}
        onSubmit={async (vals, { setErrors, setStatus, setSubmitting }) => {
          setStatus(null);
          try {
            setSubmitting(true);
            await submitReference({
              referenceId,
              referenceRequestId,
              status: 'declined',
              ...vals,
            });
            afterSubmit();
          } catch (error) {
            setStatus(error);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({
          values,
          isSubmitting,
          setFieldValue,
        }: FormikProps<DeclineReferenceValues>) => (
          <Form
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Flex mb={4} width="100%">
              <FormControl id="declineComment" mb={2} width="100%">
                <Textarea
                  value={values.declineComment}
                  onChange={(e) =>
                    setFieldValue('declineComment', e.currentTarget.value)
                  }
                  placeholder="Add comment"
                  _placeholder={{
                    fontSize: '16px',
                    color: '#666666',
                  }}
                />
              </FormControl>
            </Flex>
            <Flex
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Button
                type="submit"
                px="56px"
                py="12px"
                borderRadius={20}
                boxShadow="lg"
                mb={4}
                fontSize="15px"
                fontWeight={400}
                bg="custom.levoYellow"
                isLoading={isSubmitting}
              >
                Submit
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Flex>
  );
};

export default DeclineReferenceForm;
